/*
 * Native Possum — np-region-popup.js
 * Behaviour for snippets/np-region-popup.liquid (see its header). Loaded deferred.
 */
(function() {
  'use strict';

  /* ---- Config ---- */
  var NOTICE_DAYS = { AU: 30, US: 30, CA: 30, GB: 30, EU: 7, OTHER: 30 };
  var COOKIE_NAME = 'np_region_offer';

  /* Named markets (AU/US/CA/GB) that currently have their own active market —
     data-np-named-markets on #npRegionModal (Liquid works it out). */
  var config = document.getElementById('npRegionModal');
  var NAMED_MARKETS = JSON.parse(config.getAttribute('data-np-named-markets') || '[]');

  /* Paused countries (EU notice): from snippets/np-market-status.liquid —
     EU countries while the European Union market isn't Active, plus CH
     (data-np-paused on #npRegionModal).
     Set the EU market back to Active and the EU drops off this list. */
  var NO_SHIP_COUNTRIES = JSON.parse(config.getAttribute('data-np-paused') || '[]');

  var VALID_REGIONS = ['AU', 'US', 'CA', 'GB', 'EU', 'OTHER'];

  /* ---- Cookie helpers ---- */
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/;SameSite=Lax';
  }

  /* ---- Debug ----
     ?np_test_region=US  force a variant (AU, US, CA, GB, EU, OTHER)
     ?np_test_geo=1      real detection, logged, gates bypassed */
  var params = new URLSearchParams(window.location.search);
  var debugRegion = params.get('np_test_region');
  if (debugRegion) debugRegion = debugRegion.toUpperCase();
  var isDebug = !!debugRegion;
  var logGeo = params.get('np_test_geo') === '1';
  var bypassGates = isDebug || logGeo;

  if (!bypassGates && getCookie(COOKIE_NAME)) return;

  if (!bypassGates && document.referrer) {
    var refHost = '';
    try { refHost = new URL(document.referrer).hostname; } catch (err) { refHost = ''; }
    if (refHost === window.location.hostname) return;
  }

  /* ---- Country detection ----
     There is no automatic redirection on this store — one domain, no
     per-market subfolders — so every visitor arrives in NZD regardless of
     location. Currency cannot identify anyone. browsing_context_suggestions
     returns detected_values.country, the visitor's real country.
     Fails silent on anything unexpected. */
  function detectCountry(callback) {
    if (typeof fetch !== 'function') { callback(null); return; }
    fetch('/browsing_context_suggestions.json?country[enabled]=true', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function(res) { return res.ok ? res.json() : null; })
      .then(function(data) {
        if (logGeo) console.log('[NP region] detection response:', data);
        var code = null;
        if (data && data.detected_values && data.detected_values.country) {
          code = data.detected_values.country.handle || null;
        }
        code = code ? String(code).toUpperCase() : null;
        if (logGeo) console.log('[NP region] country code read as:', code);
        callback(code);
      })
      .catch(function(err) {
        if (logGeo) console.log('[NP region] detection failed:', err);
        callback(null);
      });
  }

  /* ---- Which variant, and which country to switch to ---- */
  function resolveRegion(done) {
    if (isDebug) {
      var forced = VALID_REGIONS.indexOf(debugRegion) !== -1 ? debugRegion : null;
      done(forced, forced);
      return;
    }

    if (typeof Shopify === 'undefined' || !Shopify.currency || !Shopify.currency.active) {
      if (logGeo) console.log('[NP region] Shopify.currency unavailable');
      done(null, null);
      return;
    }

    var currency = Shopify.currency.active;
    if (logGeo) console.log('[NP region] Shopify.currency.active:', currency);

    /* Already localised — they have chosen, or been placed. Nothing to offer. */
    if (currency !== 'NZD') { done(null, null); return; }

    detectCountry(function(code) {
      if (!code || code === 'NZ') { done(null, null); return; }
      if (NO_SHIP_COUNTRIES.indexOf(code) !== -1) { done('EU', null); return; }
      if (NAMED_MARKETS.indexOf(code) !== -1) { done(code, code); return; }
      done('OTHER', code);
    });
  }

  /* ---- Show ---- */
  function startNotice(region, switchCountry) {
    var regionForm = document.getElementById('npRegionForm');
    var regionInput = document.getElementById('npRegionCountryInput');
    var modal = document.getElementById('npRegionModal');
    var backdrop = document.getElementById('npRegionBackdrop');
    var sheet = document.getElementById('npRegionSheet');
    var sheetOverlay = document.getElementById('npRegionSheetOverlay');

    function activateVariant(container) {
      if (!container) return;
      container.querySelectorAll('.np-region-variant').forEach(function(v) {
        if (v.getAttribute('data-region') === region) {
          v.classList.add('np-region-active');
        } else {
          v.classList.remove('np-region-active');
        }
      });
    }

    activateVariant(modal);
    activateVariant(sheet);

    /* ---- Focus, inert and Escape: shared npLayer helper (np-utilities.js).
         No trigger — focus returns to whatever had it before the popup.
         The backdrop / overlay is the layer's backdrop: a tap there closes. ---- */
    var openPanel = null;

    function openDialog(dialog, outside) {
      if (!dialog) return;
      openPanel = dialog;
      /* Same first focus as before: the close button of the active variant. */
      var first = Array.prototype.find.call(dialog.querySelectorAll('button:not([disabled])'), function(el) {
        return el.offsetParent !== null;
      });
      window.npLayer.open(dialog, {
        backdrop: outside,
        initialFocus: first,
        onRequestClose: closeNotice
      });
    }

    function releaseDialog() {
      if (openPanel) window.npLayer.close(openPanel);
      openPanel = null;
    }

    function rememberChoice() {
      if (bypassGates) return;
      setCookie(COOKIE_NAME, '1', NOTICE_DAYS[region] || 30);
    }

    /* ---- Close only. Never submits the form. ---- */
    function closeNotice() {
      if (backdrop) backdrop.classList.remove('active');
      if (modal) modal.classList.remove('active');
      if (sheetOverlay) sheetOverlay.classList.remove('active');
      if (sheet) sheet.classList.remove('active');
      rememberChoice();
      releaseDialog();
    }

    /* ---- Switch. The form submit is the only thing that changes the market
         server-side — never remove it. Inert in debug: the query param
         survives the reload and would re-open the popup in a loop. ---- */
    function switchRegion() {
      if (bypassGates || !switchCountry || !regionForm || !regionInput) {
        closeNotice();
        return;
      }
      rememberChoice();
      regionInput.value = switchCountry;
      regionForm.submit();
    }

    document.querySelectorAll('.np-region-close-btn').forEach(function(btn) {
      btn.addEventListener('click', closeNotice);
    });

    document.querySelectorAll('.np-region-switch-btn').forEach(function(btn) {
      btn.addEventListener('click', switchRegion);
    });


    var touchY = 0;
    if (sheet) {
      sheet.addEventListener('touchstart', function(e) { touchY = e.changedTouches[0].screenY; }, { passive: true });
      sheet.addEventListener('touchend', function(e) { if (e.changedTouches[0].screenY - touchY > 60) closeNotice(); }, { passive: true });
    }

    var delay = isDebug ? 100 : 2000;

    setTimeout(function() {
      if (window.innerWidth >= 991) {
        if (modal) modal.classList.add('np-region-ready');
        if (backdrop) backdrop.classList.add('np-region-ready');
        requestAnimationFrame(function() {
          if (modal) modal.classList.add('active');
          if (backdrop) backdrop.classList.add('active');
          openDialog(modal, backdrop);
        });
      } else {
        if (sheet) sheet.classList.add('active');
        if (sheetOverlay) sheetOverlay.classList.add('active');
        openDialog(sheet, sheetOverlay);
      }
    }, delay);
  }

  resolveRegion(function(region, switchCountry) {
    if (region) startNotice(region, switchCountry);
  });

})();
